import { useCallback, useRef, useState } from "react";

/**
 * Pick the few actions that fit the compact mobile bar.
 * Prefer an explicit mainButton (usually Rediger / Ny), then visible non-menu actions.
 */
export function pickHseCompactActions({ actions = [], mainButton, limit = 3 } = {}) {
  const picked = [];
  if (mainButton && mainButton.hidden !== true) {
    picked.push({ ...mainButton, compactPrimary: true });
  }
  for (const action of actions || []) {
    if (!action || action.hidden === true || action.menu === true || action.component) {
      continue;
    }
    picked.push(action);
    if (picked.length >= limit) break;
  }
  return picked.slice(0, limit);
}

/**
 * One-shot busy flag for export / PDF / send / approve / publish.
 * Disables sibling one-shots while a request is in flight.
 */
export function useHseBusyAction() {
  const [busyKey, setBusyKey] = useState(null);
  const busyRef = useRef(null);

  const run = useCallback(async (key, fn) => {
    if (busyRef.current) return undefined;
    busyRef.current = key;
    setBusyKey(key);
    try {
      return await fn();
    } finally {
      busyRef.current = null;
      setBusyKey(null);
    }
  }, []);

  const isBusy = useCallback(
    (key) => (key == null ? Boolean(busyKey) : busyKey === key),
    [busyKey]
  );

  const busyProps = useCallback(
    (key) => ({
      loading: busyKey === key,
      disabled: Boolean(busyKey),
    }),
    [busyKey]
  );

  return { busyKey, run, isBusy, busyProps };
}
